export const TOGGLE_PRICE_AREA = 'TOGGLE_PRICE_AREA'

export function showPriceAreaReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_PRICE_AREA:
            return action.payload
        default: return state
    }
}